import tool from 'tool';
console.log(tool.getHiddenValues('#js-hidden-global'));
let globalHiddenParams = tool.getHiddenValues('#js-hiddens');

if (globalHiddenParams.skin_on_off === '1') {
    let style = $('<style>');
    let html = [];

    if (globalHiddenParams.skin_config.pc_skin !== '') {
        html.push(
            `.index-list .bg-content {
                background-image: url(
                    ${globalHiddenParams.skin_config.pc_skin}
                );
                background-size: 100% auto!important;
                background-position: center top!important;
                background-repeat: no-repeat!important;
            }
            .index-list .nav .goods-nav li.active {
                background: #fff!important;
            }
            .index-list .nav .goods-nav li.active a {
                color: #fb1e46!important;
            }
            .index-list .nav .goods-nav li a {
                font-weight: bold!important;
                color: #fff!important;
            }
            .index-list .filtrate li.active a {
                color: #fb1e46!important;
            }
            .index-list .filtrate li.active .arrows-icon .up {
                border-bottom: 6px solid #fb1e46!important;
            }
            .index-list .filtrate li.active .arrows-icon .down {
                border-top: 6px solid #fb1e46!important;
            }
            `
        );
    }
    if (globalHiddenParams.skin_config.index_title !== '') {
        let index_title = globalHiddenParams.skin_config.index_title;
        html.push(
            `.index-list .nav .brand {
                color: #fff!important;
            }
            `
        );
        if (/(.png)$|(.jpg)$|(.jpeg)$|(.gif)$|(.bmp)$/.test(index_title)) {
            html.push(
                `.index-list .nav .brand {
                    margin: 5px 40px 5px 0!important;
                    font-size: 0!important;
                }
                .index-list .nav .brand span {
                    background-image: url(
                        ${globalHiddenParams.skin_config.index_title}
                    )!important;
                    width: 294px!important;
                    height: 75px!important;
                    display: inline-block!important;
                    background-size: contain!important;
                    vertical-align: middle!important;
                    margin-right: 10px!important;
                    background-repeat: no-repeat!important;
                    background-position: left center!important;
                }
                `
            );
        }
    }
    if (globalHiddenParams.skin_config.panic_icon !== '') {
        html.push(
            `.index-list .list .item a .seckill {
                background-image: url(
                    ${globalHiddenParams.skin_config.panic_icon}
                ) !important;
                width: 60px !important;
                height: 60px !important;
                right: 5px !important;
                top: 5px !important;
                font-size: 0 !important;
                background-size: contain!important;
                background-position: center!important;
                background-repeat: no-repeat!important;
                padding: 0!important;
            }
            `
        );
    }
    if (globalHiddenParams.skin_config.panic_banner !== '') {
        html.push(
            `#goods-desc .right-box .seckill {
                background-image: url(
                    ${globalHiddenParams.skin_config.panic_banner}
                ) !important;
                background-size: cover!important;
                background-position: center!important;
                background-repeat: no-repeat!important;
            }
            `
        );
    }
    style.html(html.join(''));
    $(document.head).append(style);
}



// WEBPACK FOOTER //
// ./src/js_modules/plugins/skin.js